import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { CNYProps } from "../../../../../types/walletTypes";
import { CountryConfig } from "../types";

interface BeneficiaryProps extends CNYProps {
  config: CountryConfig;
}

const Beneficiary = ({ handleNext, handlePrevious, config }: BeneficiaryProps) => {
  const countryKey = (config.dataSliceKey || config.code).toLowerCase();
  const asiaPayoutData = useAppSelector((state) => (state.formData as any)?.asiaPayoutData);
  const getSavedData = asiaPayoutData?.[countryKey] || {};

  const paymentMethod = getSavedData?.paymentMethod;

  const CurrentStepComponent =
    (config.formRegistry.beneficiary?.[paymentMethod] as any) ||
    (config.formRegistry.beneficiary?.default as any);

  if (!CurrentStepComponent) return null;

  return (
    <CurrentStepComponent
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      config={config}
    />
  );
};

export default Beneficiary;
